<template>
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_b_17719_77847)">
      <rect
        width="48"
        height="48"
        rx="24"
        fill="white"
        fill-opacity="0.8"
      />
      <path
        d="M31.4322 24.98C31.4722 24.66 31.5022 24.34 31.5022 24C31.5022 23.66 31.4722 23.34 31.4322 23.02L33.5422 21.37C33.7322 21.22 33.7822 20.95 33.6622 20.73L31.6622 17.27C31.5722 17.11 31.4022 17.02 31.2222 17.02C31.1622 17.02 31.1022 17.03 31.0522 17.05L28.5622 18.05C28.0422 17.65 27.4822 17.32 26.8722 17.07L26.4922 14.42C26.4622 14.18 26.2522 14 26.0022 14H22.0022C21.7522 14 21.5422 14.18 21.5122 14.42L21.1322 17.07C20.5222 17.32 19.9622 17.66 19.4422 18.05L16.9522 17.05C16.8922 17.03 16.8322 17.02 16.7722 17.02C16.6022 17.02 16.4322 17.11 16.3422 17.27L14.3422 20.73C14.2122 20.95 14.2722 21.22 14.4622 21.37L16.5722 23.02C16.5322 23.34 16.5022 23.67 16.5022 24C16.5022 24.33 16.5322 24.66 16.5722 24.98L14.4622 26.63C14.2722 26.78 14.2222 27.05 14.3422 27.27L16.3422 30.73C16.4322 30.89 16.6022 30.98 16.7822 30.98C16.8422 30.98 16.9022 30.97 16.9522 30.95L19.4422 29.95C19.9622 30.35 20.5222 30.68 21.1322 30.93L21.5122 33.58C21.5422 33.82 21.7522 34 22.0022 34H26.0022C26.2522 34 26.4622 33.82 26.4922 33.58L26.8722 30.93C27.4822 30.68 28.0422 30.34 28.5622 29.95L31.0522 30.95C31.1122 30.97 31.1722 30.98 31.2322 30.98C31.4022 30.98 31.5722 30.89 31.6622 30.73L33.6622 27.27C33.7822 27.05 33.7322 26.78 33.5422 26.63L31.4322 24.98ZM29.4522 23.27C29.4922 23.58 29.5022 23.79 29.5022 24C29.5022 24.21 29.4822 24.43 29.4522 24.73L29.3122 25.86L30.2022 26.56L31.2822 27.4L30.5822 28.61L29.3122 28.1L28.2722 27.68L27.3722 28.36C26.9422 28.68 26.5322 28.92 26.1222 29.09L25.0622 29.52L24.9022 30.65L24.7022 32H23.3022L22.9522 29.52L21.8922 29.09C21.4622 28.91 21.0622 28.68 20.6622 28.38L19.7522 27.68L18.6922 28.11L17.4222 28.62L16.7222 27.41L17.8022 26.57L18.6922 25.87L18.5522 24.74C18.5222 24.43 18.5022 24.2 18.5022 24C18.5022 23.8 18.5222 23.57 18.5522 23.27L18.6922 22.14L17.8022 21.44L16.7222 20.6L17.4222 19.39L18.6922 19.9L19.7322 20.32L20.6322 19.64C21.0622 19.32 21.4722 19.08 21.8822 18.91L22.9422 18.48L23.1022 17.35L23.3022 16H24.6922L25.0422 18.48L26.1022 18.91C26.5322 19.09 26.9322 19.32 27.3322 19.62L28.2422 20.32L29.3022 19.89L30.5722 19.38L31.2722 20.59L30.2022 21.44L29.3122 22.14L29.4522 23.27ZM24.0022 20C21.7922 20 20.0022 21.79 20.0022 24C20.0022 26.21 21.7922 28 24.0022 28C26.2122 28 28.0022 26.21 28.0022 24C28.0022 21.79 26.2122 20 24.0022 20ZM24.0022 26C22.9022 26 22.0022 25.1 22.0022 24C22.0022 22.9 22.9022 22 24.0022 22C25.1022 22 26.0022 22.9 26.0022 24C26.0022 25.1 25.1022 26 24.0022 26Z"
        fill="#475467"
      />
    </g>
    <defs>
      <filter
        id="filter0_b_17719_77847"
        x="-48"
        y="-48"
        width="144"
        height="144"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feGaussianBlur
          in="BackgroundImage"
          stdDeviation="24"
        />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_17719_77847"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_17719_77847"
          result="shape"
        />
      </filter>
    </defs>
  </svg>

</template>

<script>
export default {
  name: 'Settings'
}
</script>